{
    "general": {
        "cancel": "Cancel",
        "close": "Close",
        "save": "Save",
        "saveAndExit": "Save and Exit",
        "delete": "Delete",
        "edit": "Edit",
        "searchPlaceholder": "Type to search",
        "no": "No",
        "yes": "Yes",
        "now": "Now",
        "showHiddenUsers": "Show hidden users",
        "login": {
            "title": "Login",
            "username": "Username",
            "password": "Password",
            "button": "Login",
            "error": {
                "invalid": "Invalid Username or Password",
                "wronguser": "Wrong Username or Password"
            }
        },
        "logout": "Logout",
        "back": "Back",
        "home": "Home",
        "pageNotFound": "This page does not exist!",
        "loading": "Loading ...",
        "refresh": "Refresh"
    },
    "barcodeScanner": {
        "title": "Scan barcode",
        "hint": "Hold the barcode inside the frame. Tap the picture to focus.",
        "retry": "Try again",
        "done": "Done",
        "torch": "Flashlight",
        "zoom": "Zoom",
        "scannedCount": "{{count}} scanned",
        "errors": {
            "insecure": "The camera is only available over a secure (HTTPS) connection.",
            "permissionDenied": "Camera access was denied. Please allow camera access in your browser settings.",
            "noCamera": "No camera was found on this device.",
            "cameraInUse": "The camera could not be started. It may be in use by another app.",
            "loadFailed": "The barcode scanner could not be loaded.",
            "unknown": "The camera could not be started."
        }
    },
    "mainmenu": {
        "home": "Home",
        "gallery": "Gallery",
        "internal": "Internal",
        "hello": "Hello, "
    },
    "footer": {
        "copyright": "Copyright © {{currentYear}} Technik AG FLG",
        "impressum": "Impressum",
        "flg": "Fanny-Leicht Gymnasium",
        "instagram": "Instagram"
    },
    "internal": {
        "menu": {
            "title": "Menu",
            "links": {
                "dashboard": "Dashboard",
                "presence": "Presence",
                "gallery": "Gallery",
                "requests": "Requests",
                "events": "Events",
                "todos": "ToDos",
                "songrequests": "Song Requests",
                "radio": "Radio",
                "inventory": "Inventory",
                "finances": "Finances",
                "users": "Users",
                "settings": "Settings"
            },
            "linkgroups": {
                "": "",
                "daily": "Daily Business",
                "management": "Management",
                "settings": "Settings"
            }
        },
        "dashboard": {
            "title": "Dashboard",
            "invItemsBack": "{{back}} of {{max}} back",
            "since": "since {{date}}",
            "missingItems": "{{amount}} missing items",
            "todoOverdue": "Overdue",
            "todosTitle": "Your open todos",
            "todosView": "View todos",
            "todosEmpty": "No todos",
            "requestsTitle": "Open requests",
            "eventsTitle": "Next events",
            "eventsView": "View events",
            "eventsEmpty": "No events",
            "inventoryTitle": "Open bookings",
            "inventoryView": "View Inventory",
            "inventoryEmpty": "No bookings",
            "financesTitle": "Pending finances",
            "financesView": "View Finances",
            "financesEmpty": "No pending finances",
            "noPermission": "No Permission"
        },
        "requests": {
            "title": "Requests",
            "name": "Name",
            "location": "Location",
            "date": "Date",
            "startDate": "Start Date",
            "endDate": "End Date",
            "contact": "Contact",
            "contactMail": "Contact Mail",
            "equipment": "Information",
            "newRequest": "New Request",
            "editTitle": "Edit Request {{name}}",
            "editTitleNew": "New Request",
            "convertToEvent": "Convert to Event",
            "convertTitle": "Convert Request to Event?",
            "convertMessage": "Are you sure you want to convert the request \"{{request.name}}\" to an event?",
            "convertProgress": "Converting Request...",
            "updateProgress": "Updating Request...",
            "createProgress": "Creating Request...",
            "deleteTitle": "Delete Request?",
            "deleteMessage": "Are you sure you want to delete the request \"{{request.name}}\"?",
            "deleteProgress": "Deleting Request..."
        },
        "events": {
            "title": "Events",
            "oldEvents": "Old Events",
            "newEvent": "New Event",
            "noEventSelected": "No Event selected",
            "name": "Name",
            "location": "Location",
            "startDate": "Start Date",
            "endDate": "End Date",
            "contact": "Contact",
            "contactMail": "Contact Mail",
            "public": "Public",
            "private": "Private",
            "description": "Description",
            "equipment": "Information",
            "documents": "Documents",
            "finances": "Finances",
            "noFinances": "No Finance Transactions",
            "inventory": "Inventory",
            "noInventory": "No Inventory Bookings",
            "images": "Images",
            "editTitle": "Edit Event {{name}}",
            "editTitleNew": "New Event",
            "financeTotal": "Total",
            "unlinkTitle": "Unlink Inventory Transaction?",
            "unlinkMessage": "Are you sure you want to unlink the inventory transaction \"{{transaction.location}}\" from the event \"{{event.name}}\"?",
            "unlinkProgress": "Unlinking Transaction...",
            "importInvTitle": "Import Inventory Transaction",
            "importInvProgress": "Importing Transaction...",
            "deleteTitle": "Delete Event?",
            "deleteMessage": "Are you sure you want to delete the event \"{{event.name}}\"?",
            "deleteProgress": "Deleting Event...",
            "updateProgress": "Updating Event...",
            "createProgress": "Creating Event..."
        },
        "inventory": {
            "title": "Inventory",
            "showTransactions": "Transactions",
            "showMissingItems": "Missing Items",
            "showGroups": "Groups",
            "startInventoryCheck": "Inventory Check",
            "newItem": "New Item",
            "newItemBulk": "New Item (Bulk)",
            "booking": "Booking",
            "printer": {
                "noSupport": "No Browser support",
                "notConnected": "Printer not connected",
                "connected": "Printer connected",
                "printing": "Printing..."
            },
            "categories": "Categories",
            "noCategorySpecified": "(No Category specified)",
            "items": "Items",
            "instances": "Instances",
            "deleteItems": "Delete Items",
            "deleteMultipleTitle": "Delete {{amount}} Items",
            "deleteMultipleMessage": "Are you sure you want to delete {{amount}} items?",
            "deleteMultipleProgress": "Deleting Items...",
            "printLabels": "Print Labels",
            "deleted": "Deleted",
            "inUse": "In Use",
            "notReturned": "Not returned",
            "returned": "Returned",
            "empty": {
                "title": "No Items",
                "subtitle": "There are no items for this filter",
                "button": "Clear Filter"
            },
            "general": {
                "itemAdded": "Item added to transaction.",
                "itemReturned": "Item returned.",
                "itemTypeReturned": "Item returned.\n Category finished.",
                "notInTransaction": "Item not part of this transaction.",
                "alreadyCheckedOut": "Item already checked out.",
                "alreadyCheckedIn": "Item already checked in.",
                "groupForbidden": "Group check-in not allowed.",
                "noInstanceID": "InstanceID not given.",
                "couldNotFindItem": "Could not find item",
                "couldNotFindItemOrGroup": "Could not find item / group for code"
            },
            "transactionList": {
                "title": "Transactions",
                "empty": {
                    "title": "No Transactions",
                    "subtitle": "There are no transactions for this filter",
                    "button": "Clear Filter"
                }
            },
            "transactionCreate": {
                "title": "Item Booking",
                "location": "Location",
                "event": "Event"
            },
            "transactionEdit": {
                "title": "Edit Transaction",
                "isAddNew": "Add new",
                "couldNotReturnItem": "Could not return item",
                "couldNotAddNewItem": "Could not add new item",
                "additionalReturned": "additional items returned"
            },
            "missingItems": {
                "title": "Missing Items",
                "empty": {
                    "title": "No missing items",
                    "subtitle": "There are no items missing"
                }
            },
            "itemEdit": {
                "titleNew": "New Item",
                "title": "Edit Item \"{{name}}\"",
                "itemDeleted": "Deleted Item",
                "name": "Name",
                "additionalInformation": "Additional Information",
                "description": "Description",
                "category": "Category",
                "barcodes": "Barcodes",
                "add": "Add",
                "showDeletedInstances": "Show Deleted Instances",
                "deleteTitle": "Delete Item?",
                "deleteMessage":"Are you sure you want to delete the item \"{{item.name}}\"?",
                "deleteInstanceTitle": "Delete Item Instance?",
                "deleteInstanceMessage":"Are you sure you want to delete {{amount}} instances of the item \"{{item.name}}\"?",
                "updateProgress": "Updating Item...",
                "createProgress": "Creating Item...",
                "deleteProgress": "Deleting Item..."
            },
            "itemHistory": {
                "title": "Item History of ",
                "empty": {
                    "title": "No History",
                    "subtitle": "This item has no history"
                },
                "create": "Item created",
                "update": "Item updated",
                "delete": "Item deleted",
                "checkout": "Item checked out to",
                "checkin": "Item checked in from",
                "showTransaction": "Show Transaction"
            },
            "groupList": {
                "title": "Groups",
                "newGroup": "New Group",
                "empty": {
                    "title": "No Groups",
                    "subtitle": "There are no groups for this filter",
                    "button": "Clear Filter"
                },
                "printGroupLabel": "Print Group Label",
                "printItemLabel": "Print Item Labels"
            },
            "barcodeEdit": {
                "title": "Edit Barcodes"
            },
            "groupEdit": {
                "title": "Edit Group",
                "name": "Group Name",
                "added":"Item added.",
                "alreadyAdded": "Item is ready in the Group.",
                "updateProgress":"Updating Group...",
                "createProgress":"Creating Group...",
                "deleteTitle": "Delete Group?",
                "deleteMessage":"Are you sure you want to delete the group \"{{group.name}}\"?",
                "deleteProgress":"Deleting Group..."
            },
            "inventoryCheck": {
                "title": "Inventory Check",
                "found": "Found",
                "notFound": "Not Found",
                "booked": "Booked",
                "clearCheckpoint": "Clear Checkpoint",
                "createProgress": "Creating Transaction...",
                "removedFromBooking": "Item was already checked-out, Now checked back in."
            },
            "transactionChecklist": {
                "loadingInformationProgress": "Loading Inventory Information",
                "generatingPDFProgress": "Generating PDF"
            }
        },
        "finances": {
            "title": "Finances",
            "startInvoice": "New Invoice",
            "newTransaction": "New Transaction",
            "deleteTransactionTitle": "Delete Finance Transaction?",
            "deleteTransactionMessage": "Are you sure you want to delete the finance transaction \"{{transaction.reason}}\"?",
            "deleteTransactionProgress": "Deleting Transaction...",
            "withPending": "Incl. Pending",
            "withoutPending": "Excl. Pending",
            "noTransactions": "No Transactions",
            "transaction": {
                "reason": "Reason",
                "income": "Income",
                "notincome": "Expense",
                "pending": "Pending",
                "notpending": "Completed",
                "date": "Date",
                "user": "User",
                "event": "Event",
                "notes": "Notes",
                "amount": "Amount",
                "attachments": "Attachments"
            },
            "transactionEdit": {
                "title": "Edit Transaction",
                "titleNew": "New Transaction",
                "updateProgress": "Updating Transaction...",
                "createProgress": "Creating Transaction...",
                "uploadFilesProgress": "Uploading Files..."
            }
        },
        "invoiceForm": {
            "title": "Invoice Form",
            "reason": "Reason",
            "date": "Date",
            "user": "User",
            "usedItems": "Used Items",
            "availableItems": "Available Items",
            "total": "Total",
            "description": "Description",
            "additionalInfo": "Additional Information",
            "quantity": "Quantity",
            "unitPrice": "Unit Price",
            "address": "Address Template",
            "addressLine": "Address Line {{line}}",
            "showQR": "Show Verification QR Code",
            "creatingTransactionProgress": "Creating Transaction",
            "uploadingInvoiceProgress": "Uploading Invoice",
            "updatingTransactionProgress": "Updating Transaction"
        },
        "todos": {
            "title": "ToDos",
            "newTodo": "New ToDo",
            "editTitle": "Edit ToDo",
            "editTitleNew": "New ToDo",
            "move": "Move",
            "status": "Status",
            "priority": "Priotity",
            "duedate": "Due Date",
            "notification": "Notification",
            "assignee": "Assignee",
            "description": "Description",
            "deleteTitle": "Delete ToDo?",
            "deleteMessage": "Are you sure you want to delete the ToDo?",
            "deleteProgress": "Deleting ToDo...",
            "updateProgress": "Updating ToDo...",
            "createProgress": "Creating ToDo..."
        },
        "presence": {
            "title": "Presence",
            "newPresence": "New Presence",
            "editTitle": "Edit Presence for ",
            "startdate": "Start Date",
            "date": "Date",
            "id": "ID",
            "name": "Name",
            "presence": "Presence",
            "percentage": "Percentage",
            "deleteTitle": "Delete presence?",
            "deleteMessage": "Are you sure you want to delete the presence information for {{date}}?",
            "deleteProgress": "Deleting Presence...",
            "updateProgress": "Updating Presence...",
            "createProgress": "Creating Presence...",
            "tooltips": {
                "0": "Absent",
                "1": "Present",
                "2": "Present, Tested",
                "3": "Excused",
                "4": "Present",
                "5": "Late",
                "-1": "Unknown"
            }
        },
        "songrequests": {
            "title": "Song Requests",
            "enabled": "Enabled",
            "disabled": "Disabled",
            "deleteAll": "Delete All",
            "songTitle": "Song Title",
            "songArtist": "Song Artist",
            "votes": "Votes",
            "played": "Played",
            "delete": "Delete",
            "spotifySearch": "Spotify",
            "deleteSongRequest": {
                "title": "Delete song request?",
                "message": "Are you sure you want to delete the song request for \"{{artist}} - {{title}}\"?",
                "progress": "Deleting Song Request..."
            },
            "deleteAllSongRequests": {
                "title": "Delete all song requests?",
                "message": "Are you sure you want to delete all song requests?",
                "progress": "Deleting Song Requests..."
            },
            "copy": {
                "copied": "Song Copied!",
                "failed": "Failed to copy song"
            }
        },
        "gallery": {
            "title": "Gallery",
            "newCategory": "New Category",
            "public": "Public",
            "notpublic": "Hidden",
            "watermark": "Watermarked",
            "nowatermark": "Not Watermarked",
            "editTitle": "Category",
            "imageTitle": "Title",
            "description": "Description",
            "event": "Event",
            "uploadText": "Drop files or click to browse",
            "uploadTextSize": "Up to 5 MB each",
            "noCategorySelected": "No Category Selected",
            "noImages": "No Images in this Category",
            "deleteTitle": "Delete Image Category?",
            "deleteMessage": "Are you sure you want to delete the image category \"{{title}}\"?",
            "deleteProgress": "Deleting Image Category...",
            "updateCategoryProgress": "Updating Image Category...",
            "createCategoryProgress": "Creating Image Category...",
            "imageUploadProgress": "Uploading Images...",
            "imageProcessingProgress": "Processing Images...",
            "reuploadHint": "Click to reupload image"
        },
        "users": {
            "title": "Users",
            "username": "Username",
            "name": "Name",
            "firstname": "Firstname",
            "lastname": "Lastname",
            "password": "Password",
            "pin": "Pin",
            "schoolclass": "Schoolclass",
            "email": "E-Mail",
            "technikEmail": "Technik E-Mail",
            "technikEmailPassword": "Technik E-Mail Password",
            "active": "Active",
            "inactive": "Inactive",
            "hidden": "Hidden",
            "visible": "Visible",
            "notSet": "Not Set",
            "newUser": "New User",
            "editTitle": "Edit User {{username}}",
            "editTitleNew": "New User",
            "editGeneralTitle": "User",
            "editSchoolTitle": "School",
            "editPermissionsTitle": "Permissions",
            "updateProgress": "Updating User...",
            "createProgress": "Creating User...",
            "deleteTitle": "Delete User?",
            "deleteMessage": "Are you sure you want to delete the user \"{{username}}\"?",
            "deleteProgress": "Deleting User...",
            "leaveEmptyHint": "Leave empty for no change.",
            "allPermissions": "All"
        },
        "document-viewer": {
            "dropText": "Drop files here to upload",
            "deleteAttachmentTitle": "Delete Attachment?",
            "deleteAttachmentMessage": "Are you sure you want to delete the attachment \"{{filename}}\"?",
            "deleteAttachmentProgress": "Deleting Attachment...",
            "uploadAttachmentProgress": "Uploading Attachment..."
        },
        "settings": {
            "title": "Settings",
            "categories": {
                "music": "Radio & Song Requests",
                "gallery": "Gallery",
                "inventory": "Inventory"
            },
            "enableSongRequests": {
                "title": "Enable Song Requests",
                "description": "Whether the song request page is publicly available and songs can be requested and voted."
            },
            "songRequestTimeouts": {
                "title": "Song Request Timeouts",
                "description": "The time in seconds users have to wait after voting and submitting a request before they can do that again."
            },
            "enableSchulradio": {
                "title": "Enable Radio",
                "description": "Whether the radio feature is enabled, allowing users to request songs. If this setting is turned on, the radio player will start playing music in the defined times and slots."
            },
            "defaultGallery": {
                "title": "Default Gallery",
                "description": "The selected default gallery will be used to pick random images for the home page and will be selected as the first image category when a user enters the gallery page."
            },
            "allowGroupsForBookIn": {
                "title": "Allow Groups for returning Items",
                "description": "If this setting is turned on, groups can be used to return items to the inventory. Is disabled, each item of the group has to be checked back in individually."
            },
            "allowReturnItemsNotInTransaction": {
                "title": "Allow returning items that are not in the current transaction",
                "description": "If this setting is turned on, items scanned in a transaction in order to return them will also be returned even if they are not checked out to the currently open transaction. If disabled, only items in the transaction currently open can be returned."
            },
            "allowItemRebooking": {
                "title": "Allow checking out items to be checked out again",
                "description": "If this setting is turned on, items can be checked out to a new transaction while they are already checked out to another transaction. Re-cheking-out will check the item back in on the old transaction. If disabled, items first have to be checked-in from the old transaction manually."
            },
            "labelTemplate": {
                "title": "Inventory Item Label Template",
                "description": "Label template used for single inventory items.<br/>The following template fields can be used:<br/>^FN1: Combined Item and Instance ID used for scanning<br/>^FN2: Item Name<br/>^FN3: Item description<br/>^FN4: Item's Additional Info"
            },
            "groupLabelTemplate": {
                "title": "Inventory Group Label Template",
                "description": "Label template used for groups of inventory items.<br/>The following template fields can be used:<br/>^FN1: Group ID<br/>^FN2: Group Name"
            }
        }
    },
    "home": {
        "aboutUsTitle": "About Us",
        "aboutUsText": "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Doloremque architecto eum nemo molestias perferendis quo repellendus voluptate odio sapiente quas aliquam tempore consequuntur enim in repellat praesentium, itaque doloribus error!",
        "eventsTitle": "Upcoming Events",
        "eventsError": "Could not load events",
        "eventsEmpty": "No upcoming events",
        "imagesTitle": "Gallery",
        "imagesError": "Could not load images",
        "imagesEmpty": "Currently there is nothing to show here"
    },
    "requests": {
        "title": "Request Technik AG for your event",
        "description": "If you need help at an event, please complete this form. We'll be in touch as soon as possible to confirm availability.",
        "submit": "Submit Request",
        "successDescription": "We have received your inquiry and will contact you shortly"
    },
    "events": {
        "nextEvents": "Next Events",
        "currentNoEvents": "There are no events at the moment",
        "eventsError": "Could not load events"
    },
    "todos": {
        "status": {
            "open": "Open",
            "inprogress": "In Progress",
            "done": "Done",
            "canceled": "Canceled"
        },
        "priority": {
            "low": "Low",
            "normal": "Normal",
            "high": "High"
        }
    },
    "gallery": {
        "amountImages": "{{amount}} Images",
        "imagesTitle": "Images",
        "categories": "Categories",
        "categoriesEmpty": "No Categories",
        "imagesEmpty": "No images in this category",
        "categoriesEroor": "Could not load categories"
    },
    "songrequests": {
        "title": "Song Requests",
        "disabled": "Song Requests are currently disabled",
        "newRequestTitle": "Submit a new Song Request",
        "sendRequest": "Submit Request",
        "songTitle": "Song Title",
        "songArtist": "Song Artist",
        "votelistTitle": "Vote for a Song",
        "playedListTitle": "Played Songs",
        "submitTimeout": "You need to wait for {{time}} before requesting a song",
        "voteTimeout": "You need to wait for {{time}} before voting again",
        "similar": {
            "title": "Duplicate Song Request",
            "message": "There is already a similar song request \"{{similar.artist}} - {{similar.title}}\" with {{similar.votes}} votes. Are you sure you want to create a new song request? This means that votes are divided and not collected together."
        }
    },
    "oauth": {
        "consent": {
            "title": "Login with OAuth",
            "text": "Do you want to login to \"{{application}}\"?",
            "acceptBtn": "Accept",
            "declineBtn": "Deny"
        },
        "denied": {
            "title": "No access",
            "text": "Your account does not have permission to log in to \"{{application}}\".",
            "backBtn": "Back to application"
        }
    },
    "permissions": {
        "base": {
            "pin_login": {
                "name": "Pin Login",
                "description": "Allows the User to login to a Workstation with a PIN"
            },
            "edit_config": {
                "name": "Edit Settings",
                "description": "Allows the User to edit the Config"
            },
            "kiosk_mode": {
                "name": "Kiosk Mode",
                "description": "Enables the Kiosk Mode for the Workstation"
            }
        },
        "oauth": {
            "login_wiki": {
                "name": "Login to Wiki",
                "description": "Allows the user to login to the Wiki"
            },
            "login_cloud": {
                "name": "Login to Cloud",
                "description": "Allows the user to login to the Cloud"
            },
            "login_mattermost": {
                "name": "Login to Mattermost",
                "description": "Allows the user to login to Mattermost"
            }
        },
        "presence": {
            "view_presence": {
                "name": "View",
                "description": "Allows the user to view the presence information"
            },
            "create_presence": {
                "name": "Create",
                "description": "Allows the user to create new presence information"
            },
            "edit_presence": {
                "name": "Edit",
                "description": "Allows the user to edit presence information"
            },
            "delete_presence": {
                "name": "Delete",
                "description": "Allows the user to delete presence information"
            },
            "edit_old_presence": {
                "name": "Modify Old Entries",
                "description": "Allows the user to edit/delete old presence information (In combination with 'Edit' and 'Delete')"
            }
        },
        "users": {
            "view_users": {
                "name": "View",
                "description": "Allows the user to view users"
            },
            "create_users": {
                "name": "Create",
                "description": "Allows the user to create new users"
            },
            "edit_users": {
                "name": "Edit",
                "description": "Allows the user to edit users"
            },
            "delete_users": {
                "name": "Delete",
                "description": "Allows the user to delete users"
            }
        },
        "inventory": {
            "view_inventory": {
                "name": "View",
                "description": "Allows the user to view the inventory"
            },
            "create_inventory_item": {
                "name": "Create",
                "description": "Allows the user to create new inventory items"
            },
            "edit_inventory_item": {
                "name": "Edit",
                "description": "Allows the user to edit inventory items"
            },
            "delete_inventory_item": {
                "name": "Delete",
                "description": "Allows the user to delete inventory items"
            },
            "inventory_booking": {
                "name": "Book",
                "description": "Allows the user to book inventory items"
            }
        },
        "todos": {
            "view_todos": {
                "name": "View",
                "description": "Allows the user to view todos"
            },
            "create_todos": {
                "name": "Create",
                "description": "Allows the user to create new todos"
            },
            "edit_todos": {
                "name": "Edit",
                "description": "Allows the user to edit todos"
            },
            "delete_todos": {
                "name": "Delete",
                "description": "Allows the user to delete todos"
            }
        },
        "events": {
            "view_events": {
                "name": "View",
                "description": "Allows the user to view events"
            },
            "create_events": {
                "name": "Create",
                "description": "Allows the user to create new events"
            },
            "edit_events": {
                "name": "Edit",
                "description": "Allows the user to edit events"
            },
            "delete_events": {
                "name": "Delete",
                "description": "Allows the user to delete events"
            }
        },
        "requests": {
            "view_requests": {
                "name": "View",
                "description": "Allows the user to view requests"
            },
            "create_requests": {
                "name": "Create",
                "description": "Allows the user to create new requests"
            },
            "edit_requests": {
                "name": "Edit",
                "description": "Allows the user to edit requests"
            },
            "delete_requests": {
                "name": "Delete",
                "description": "Allows the user to delete requests"
            },
            "promote_to_event": {
                "name": "Promote to Event",
                "description": "Allows the user to promote requests to events"
            }
        },
        "song requests": {
            "view_songrequests": {
                "name": "View",
                "description": "Allows the user to view song requests"
            },
            "edit_songrequests": {
                "name": "Edit",
                "description": "Allows the user to edit song requests"
            },
            "delete_songrequests": {
                "name": "Delete",
                "description": "Allows the user to delete song requests"
            }
        },
        "schulradio": {
            "view_schulradio": {
                "name": "View",
                "description": "Allows the user to view the Schulradio"
            },
            "control_breaks": {
                "name": "Control Breaks",
                "description": "Allows the user to control the breaks"
            },
            "control_playback": {
                "name": "Control Playback",
                "description": "Allows the user to control the playback"
            },
            "control_playlist": {
                "name": "Control Playlist",
                "description": "Allows the user to control the playlist"
            },
            "control_player": {
                "name": "Control Player",
                "description": "Allows the user to control the player"
            }
        },
        "images": {
            "create_category": {
                "name": "Create Categories",
                "description": "Allows the user to create new image categories"
            },
            "view_private_categories": {
                "name": "View Private Categories",
                "description": "Allows the user to view private image categories"
            },
            "edit_category": {
                "name": "Edit Categories",
                "description": "Allows the user to edit image categories"
            },
            "delete_category": {
                "name": "Delete Categories",
                "description": "Allows the user to delete image categories"
            },
            "view_private_images": {
                "name": "View Private Images",
                "description": "Allows the user to view private images"
            },
            "create_image": {
                "name": "Create Images",
                "description": "Allows the user to create new images"
            },
            "edit_image": {
                "name": "Edit Images",
                "description": "Allows the user to edit images"
            },
            "delete_image": {
                "name": "Delete Images",
                "description": "Allows the user to delete images"
            }
        },
        "finances": {
            "view_finances": {
                "name": "View",
                "description": "Allows the user to view finances"
            },
            "create_finances": {
                "name": "Create",
                "description": "Allows the user to create new finances"
            },
            "edit_finances": {
                "name": "Edit",
                "description": "Allows the user to edit finances"
            },
            "delete_finances": {
                "name": "Delete",
                "description": "Allows the user to delete finances"
            }
        }
    },
    "errors": {
        "couldNotLoadUsers": "Could not load users",
        "couldNotLoadEvent": "Could not load event",
        "couldNotLoadEvents": "Could not load events",
        "couldNotLoadRequests": "Could not load requests",
        "couldNotLoadSongRequests": "Could not load song requests",
        "couldNotLoadTodos": "Could not load todos",
        "couldNotLoadFinanceTransactions": "Could not load finance transactions",
        "couldNotLoadInventoryTransaction": "Could not load inventory transaction",
        "couldNotLoadInventoryTransactions": "Could not load inventory transactions",
        "couldNotLoadInventoryItems": "Could not load inventory items",
        "couldNotLoadInventoryGroups": "Could not load inventory groups",
        "couldNotLoadInventoryCategories": "Could not load inventory categories",
        "couldNotLoadImages": "Could not load images",
        "couldNotLoadImageCategory": "Could not load image category",
        "couldNotLoadImageCategories": "Could not load image categories",
        "couldNotLoadPresenceInformation": "Could not load presence information",
        "couldNotCreateTransaction": "Could not create transaction",
        "couldNotUpdateSongRequestsPlayed": "Could not update song request played status",
        "couldNotProcessSongRequest": "Could not process your song request",
        "couldNotProcessSongVote": "Could not process your song vote",
        "couldNotUpdateTodo": "Could not update todo",
        "couldNotSaveSettings": "Could not save settings",
        "couldNotDeleteNewImage": "Could not delete new image",
        "couldNotConnectToPrinter": "Could not connect to printer",
        "imageUploadErrors": {
            "newImage": "New Image: {{message}}",
            "reuploadedImage": "Reuploaded Image: {{message}}",
            "updatedImage": "Update Image: {{message}}",
            "removedImage": "Removed Image: {{message}}"
        }
    }
}